<template>
  <v-card class="rounded-lg">
    <!-- Header -->
    <v-card-title class="d-flex justify-space-between align-center">
      <div>
        <div class="font-weight-bold">
          <v-icon size="18" class="me-1">mdi-file-document-multiple</v-icon>
          Documents
        </div>
        <div class="text-caption text-grey">
          Folder: {{ folderName || 'All Documents' }}
        </div>
      </div>

      <div class="d-flex gap-2">
        <v-text-field
          v-model="search"
          density="compact"
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
        />
      </div>
    </v-card-title>

    <v-divider />

    <!-- Table -->
    <v-data-table
      :headers="headers"
      :items="filteredDocs"
      item-key="id"
      density="compact"
      class="elevation-0"
    >
      <template v-slot:item.index="{ index }">
        {{ ++index }}
      </template>

      <template v-slot:item.title="{ item }">
        {{ item.title }} <br>
        <span class="blue">Folder:</span> {{ item.folder_path }}
      </template>

      <template v-slot:item.latest_version="{ item }">
        {{ item.latest_version.version_no }}
      </template>

      <!-- Status -->
      <!-- <template #item.status="{ item }">
        <v-chip
          size="small"
          :color="statusColor(item.status)"
          variant="tonal"
        >
          {{ item.status }}
        </v-chip>
      </template> -->

      <template #item.updated_at="{ item }">
          {{ formatDate(item.updated_at) }}
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
    
        <v-btn
          icon="mdi-eye"
          size="small"
          variant="text"
          color="info"
          @click="$emit('view', item)"
          title="View Document"
        />

        <v-btn
          icon="mdi-download"
          size="small"
          variant="text"
          color="primary"
          @click="download(item)"
          title="Download Document"
        />

        <v-btn
          v-if="item.status === 'Approved'"
          icon="mdi-plus-box-outline"
          size="small"
          variant="text"
          color="secondary"
          @click="$emit('new-version', item)"
          title="New Version"
        />

        <v-btn
          icon="mdi-delete"
          size="small"
          variant="text"
          color="error"
          @click="remove(item)"
          v-if="$deleteAccess($route.fullPath)"
          title="Delete Document"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import axios from 'axios';
import { prefix, fileServerUrl } from '@/store/api';

const props = defineProps({
  folderId: Number,
  folderName: String,
})

const documents = ref([])
const search = ref('')

const headers = [
  { title: "SL", align: "center", key: "index", width: "5%", sortable: false},
  { title: 'Doc No', key: 'code', align: "center" },
  { title: 'Title', key: 'title', align: "center" },
  { title: 'Version', key: 'latest_version', align: "center" },
  { title: 'Status', key: 'approval_status', align: "center" },
  { title: 'Updated', key: 'updated_at', align: "center", },
  { title: 'Actions', key: 'actions', sortable: false, align: "center" },
]

const loadDocuments = async () => {
  const { data } = await axios.get(`${prefix}cms/files`, {
    params: { folder_id: props.folderId },
  })
  documents.value = data.data
}

watch(
  () => props.folderId,
  async () => {
    await loadDocuments()
  },
  { immediate: true }
)

const filteredDocs = computed(() => {
  if (!search.value) return documents.value
  const q = search.value.toLowerCase()

  // console.log(documents.value)

  return documents.value.filter(
    d =>
      d.title.toLowerCase().includes(q) ||
      d.doc_no.toLowerCase().includes(q)
  )
})

const statusColor = status => {
  return {
    Draft: 'grey',
    Approved: 'green',
    Rejected: 'red',
    'In Review': 'blue',
  }[status] || 'grey'
}

const formatDate = (date) => {
  return date.split('T')[0]
}

// const download = async item => {
//   const link = document.createElement('a')
//   link.href = `${fileServerUrl}${item.latest_version.path}`
//   link.download = item.title
//   document.body.appendChild(link)
//   link.click()
//   document.body.removeChild(link)

//   //  try {
//     // const { data } = await axios.get(`${fileServerUrl}${item.latest_version.path}`, {
//     //   responseType: 'blob'
//     // })
//     // const link = document.createElement('a')
//     // link.href = URL.createObjectURL(data)
//     // link.download = item.title
//     // document.body.appendChild(link)
//     // link.click()
//     // document.body.removeChild(link)
//     // URL.revokeObjectURL(link.href)
//   // } catch (error) {
//   //   console.error('Download failed:', error)
//   // }
// }

const download = item => {
  const link = document.createElement('a')
  link.href = `${fileServerUrl}${item.latest_version.path}`
  link.download = item.title
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const remove = async item => {
  await axios.delete(`/files/${item.id}`)
  loadDocuments()
}
</script>
